import { faMagnifyingGlass, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useLocation } from "react-router-dom";
import SearchBar from "../SearchBar";

function TopbarSearch({
  isMobileView,
  handleSubmit,
  scButton,
  handleChange,
  clearSearch,
  search,
  handleCategory,
  setSearch,
}) {
  const location = useLocation()

    const pathSegments2 = location.pathname.split("/"); // ['', 'buysell', '123']

  // Hide the form if route is /buysell or /buysell/:id (number), or /charts
  // const shouldHideForm =
  //   pathSegments2[1] === "buysell" && (!pathSegments2[2] || /^\d+$/.test(pathSegments2[2])) ||
  //   pathSegments2[1] === "charts" || pathSegments2[1] === "search" ;


const shouldHideForm =
  pathSegments2[1] === "buysell" ||
  pathSegments2[1] === "charts" ||
  pathSegments2[1] === "search" ||
  pathSegments2[1] === "chartSearch";

  // Hide the search field on DESKTOP for the /portfolio page only (matches the
  // title/strip removal there — the sidebar already marks the page). Separate
  // from shouldHideForm; the `md:hidden` keeps it visible on mobile, and every
  // other route is unaffected.
  // Matches /portfolio and /portfolio/:userId (viewing another user's
  // portfolio). Does NOT match /portfolionew or /oldportfolio.
  const isPortfolioPath = /^\/portfolio(\/[^/]+)?$/.test(location.pathname);


  const pathSegments = window.location.pathname.split("/");
  const isChartsPath = location.pathname.endsWith("/charts");
  // console.log("klsdfjsldkfk", isMobileView , isChartsPath)

    const validPaths = ["charts"];

    // Extract the first segment (slug) and the second segment of the path
    const pathSegments1 = location.pathname.split("/");

    // The first segment is the slug (e.g., "new")
    const slug = pathSegments[1];

    // The second segment is the valid path (e.g., "buysell")
    const pathSegment = pathSegments1[2];

    // Check if the second segment matches any of the valid paths
    const isValidPath = validPaths.includes(pathSegment);

  return (
    <div
      className={
        isMobileView && pathSegments[1] === "chartSearch"
          ? "md:w-1/4 py-2 items-center flex"
          : isMobileView && pathSegments[1] === "charts"
          ? "md:w-1/4 py-2 items-center flex"
          : `pr-2 md:w-1/4 ${isValidPath ? "pb-4" : "py-4"}  items-center flex`
      }
    >

    {!shouldHideForm && (
      <form
        onSubmit={handleSubmit}
        className={`max-md:w-full ${isPortfolioPath ? "md:hidden" : ""}`}
      >
        <input
          type="text"
          placeholder="Search..."
          value={search}
          onChange={handleChange}
          className={`border rounded-full text-sm w-full p-3 py-2 focus:outline-none focus:border-green-300 bg-slate-50 ${
            isMobileView ? "mt-0" : "md:w-[230px]"
          }`}
        />
      </form>
      )}

    {!(
        isMobileView &&
        pathSegments2[1] === "search"
      ) && shouldHideForm && (
      <SearchBar
        newsearch={search}
        newhandleChange={handleChange}
        newonSubmit={handleSubmit}
        newsetCategory={handleCategory}
      />
    )}



<div>
  {/* Show search icon only if shouldHideForm is false */}
  {!shouldHideForm && !scButton && (
    <FontAwesomeIcon
      onClick={handleSubmit}
      className={
        isMobileView
          ? "-ml-7 mt-3 mb-1 text-slate-500"
          : "-ml-8 mb-2 mt-3"
      }
      icon={faMagnifyingGlass}
    />
  )}

  {/* Show close icon if shouldHideForm is false and scButton is true */}
  {!shouldHideForm && scButton && (
    <FontAwesomeIcon
      icon={faTimes}
      className={
        isMobileView
          ? "-ml-7 mt-4 cursor-pointer text-slate-500"
          : "ml-20 cursor-pointer text-slate-500"
      }
      onClick={clearSearch}
    />
  )}
</div>


    </div>
  );
}

export default TopbarSearch;
